const MoodType = {
  '烦躁': {
    key: '烦躁',
    color: '#E54C1D',
  },
  '愤怒': {
    key: '愤怒',
    color: '#E54C1D',
  },
  '消极': {
    key: '消极',
    color: '#E54C1D',
  },
  '感谢': {
    key: '感谢',
    color: '#1990FF',
  },
  '积极': {
    key: '积极',
    color: '#1990FF',
  },
  '中等': {
    key: '中等',
    color: '#1990FF',
  },
}

const QcType = {
  compliance: 1,
  moc: 2,
  scenarioTag: 3,
}

export {
  MoodType,
  QcType,
}
